// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"1f985a13","821":"a13f17e7"}[chunkId] + ".chunk.js";
};